import Cookies from "js-cookie";
import { AUTH_SETTINGS, AUTH_LOGIN, AUTH_LOGOUT } from "./types";

export default {
  [AUTH_SETTINGS]: (state, settings) => {
    state.settings = settings;
  },

  [AUTH_LOGIN]: (state, { key, username }) => {
    Cookies.set("token_cabinet", key, { expires: 30 });
    Cookies.set("username_cabinet", username, { expires: 30 });
    state.token = key;
    state.username = username;
  },

  [AUTH_LOGOUT]: state => {
    Cookies.remove("token_cabinet");
    Cookies.remove("username_cabinet");
    state.token = null;
    state.username = null;
  }
};
